import axios from 'axios'

export default ({
    namespaced: true,
    state: {
        intentions: null,
        selected:   null,
    },
    
    getters:{
        selected(state){
            return state.selected
        },
        intentions(state){
            return state.intentions
        },
    },

    mutations: {
        SET_INTENTIONS(state, data) {
            state.intentions = data
        },
        SET_SELECTED(state, data) {
            state.selected = data
        },
    },

    actions: {
        async getOrderSelected({commit}, data ) {
            try {
                let response = await axios.get(`orders-intentions/${data.id}`)
                commit('SET_SELECTED', response.data)
            } catch (e) {
                throw Error;
            }
        },
        async getOrdersIntentions({commit}) {
            try {
                let response = await axios.get('orders-intentions')
                commit('SET_INTENTIONS', response.data)
            } catch (e) {
                throw Error;
            }
        },
    }
})
